import { render } from "./Error404.vue?vue&type=template&id=f2efe424&scoped=true&ts=true"
import script from "./Error404.vue?vue&type=script&lang=ts"
export * from "./Error404.vue?vue&type=script&lang=ts"

import "./Error404.vue?vue&type=style&index=0&id=f2efe424&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2efe424"]])

export default __exports__